import * as React from 'react'
import type { SVGProps } from 'react'
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4771 6.70711C18.8677 6.31658 18.8677 5.68342 18.4771 5.29289C18.0866 4.90237 17.4534 4.90237 17.0629 5.29289L11.77 10.5858L6.47713 5.29289C6.0866 4.90237 5.45344 4.90237 5.06291 5.29289C4.67239 5.68342 4.67239 6.31658 5.06291 6.70711L10.3558 12L5.06291 17.2929C4.67239 17.6834 4.67239 18.3166 5.06291 18.7071C5.45344 19.0976 6.0866 19.0976 6.47713 18.7071L11.77 13.4142L17.0629 18.7071C17.4534 19.0976 18.0866 19.0976 18.4771 18.7071C18.8677 18.3166 18.8677 17.6834 18.4771 17.2929L13.1842 12L18.4771 6.70711Z"
      fill="#190900"
    />
  </svg>
)
export default SvgClose
